import { render } from "./TourHost.vue?vue&type=template&id=61bbd8ac&scoped=true"
import script from "./TourHost.vue?vue&type=script&lang=js"
export * from "./TourHost.vue?vue&type=script&lang=js"

import "./TourHost.vue?vue&type=style&index=0&id=61bbd8ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61bbd8ac"]])

export default __exports__